

import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid } from '@mui/material';
import { CssTextField } from '../elements';
import { Typography } from '@mui/material';
import { useAuth } from '../../../hooks/useAuth';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import TocIcon from '@mui/icons-material/Toc';
import PropTypes from 'prop-types';
import { blue } from '@mui/material/colors';
import MaterialSelectAuto from '../../materials/mat-select-auto';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ProgramLangSelect from '../dialog/untils/select-lang';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import { getLangProgramTag, getSellStatusTag } from '../../../services/material-services';
import SelectSearchAuto from '../dialog/untils/select-search';
import { getUsers } from '../../../services/user-services';


export default function ReportFilter({userClient, ReqUser, onClose}) {
    const { authData, authDataLang } = useAuth()
    // const { onClose, selectedValue, open } = props
    const [isAdmin, setIsAdmin] = useState(false)
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    const [matName, setMatName ] = useState(null)
    const [projectName, setProjectName] = useState()
    const [programmerLang, setProgrammerLang] = useState('')
    
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')

    const [estimateCredit, setEstimateCredit] = useState(0)
    const [totalCredit, setTotalCredit] = useState(0)

    const [dataUsers, setDataUsers] = useState('')
    const [selectUser, setSelectUser] = useState('')

    const [langProgram, setLangProgram] = useState('')
    
    const [sellStsList, setSellStsList] = useState('')
    const [sellStsSelect, setSellStsSelect] = useState('')

    const handlerLangSelect = value => {
        // console.log("handlerLangSelect", value)
        setProgrammerLang(value)
    }

    const handlerUserSelect = value => {
        // console.log("handlerLangSelect", value)
        setSelectUser(value)
    }

    const handlerStatusSelect = value => {
        // console.log("handlerLangSelect", value)
        setSellStsSelect(value)
    }

    useEffect(()=>{
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium)
        }
        setLoading(true)
        
        const getData = async() =>{
            await getLangProgramTag(authData?.token)
            .then(data => {
                
                // console.log("setLangProgram", data)
                setLangProgram(data)

                setLoading(false)
            }).catch( e => {
                setError(true)
                setLoading(false)
            })
        }
        getData()
    }, [authData])

    useEffect(()=>{
        const getData = async() =>{
            setLoading(true)
            await getSellStatusTag(authData?.token)
            .then(data => {
                
                // console.log("setLangProgram", data)
                setSellStsList(data)

                setLoading(false)
            }).catch( e => {
                setError(true)
                setLoading(false)
            })
        }
        getData()
    }, [authData])

    useEffect(() => {
        const users = async() => {
            setLoading(true)
            setError(false)
            await getUsers(authData?.token)
            .then(data => {
                setLoading(false)
                console.log("getUsers", data)
                setDataUsers(data?.results)
            }).catch(err => {
                setError(true)
                setLoading(false)
            })
        }
        if(isAdmin){
            users()
        }
    }, [authData, isAdmin])


    const handelSubmitInsert = async() => {
        var ResultFilter = {}
        
        if (matName?.id){
            // ResultFilter.push({mat_id : matName.id})
            ResultFilter["mat_id"] = matName.id
            
        }
        if (projectName){
            // ResultFilter.push({title : projectName})
            ResultFilter["title"] = projectName
        }
        if (programmerLang.length > 0){
            // ResultFilter.push({lang_id : programmerLang})
            ResultFilter["lang_id"] = programmerLang
        }
        if (dateFrom){
            // ResultFilter.push({date_from : dateFrom})
            ResultFilter["date_from"] = dateFrom
        }
        if (dateTo){
            // ResultFilter.push({date_to : dateTo})
            ResultFilter["date_to"] = dateTo
        }
        if (estimateCredit){
            // ResultFilter.push({start_money : estimateCredit})
            ResultFilter["start_money"] = estimateCredit
        }
        if (totalCredit){
            // ResultFilter.push({end_money : totalCredit})
            ResultFilter["end_money"] = totalCredit
        }
        if (selectUser?.id > 0){
            // ResultFilter.push({user_id : selectUser.id})
            ResultFilter["user_id"] = selectUser.id
        }
        if (sellStsSelect.length > 0){
            // ResultFilter.push({status_req : sellStsSelect})
            ResultFilter["status_req"] = sellStsSelect
        }

        
        onClose(ResultFilter)
    }

    const handleMatSelect = value => {
        setMatName(value)
    }

  return (
    <div style={{direction: 'rtl'}}>
        <Accordion sx={{backgroundColor: blue[900], margin: 1}}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{color: 'pink.text'}}/>}
                aria-controls="panel2a-content"
                id="panel2a-header"
                >
                <Typography
                    fontFamily='b_mitra' 
                    component="div"
                    variant="h6"
                    color={"pink.text"}
                    >
                    جستجوی پیشرفته
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div style={{backgroundColor: 'white', padding: 10}} >
                    <br/>
                    <Grid container sx={{marginTop: 1, marginRight:1, marginLeft:1}}>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid container spacing={1} alignItems='flex-end'>
                                <Grid item>
                                    <TocIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item >
                                    <MaterialSelectAuto
                                        onChange={handleMatSelect}
                                        selectedValue={matName} />
                                </Grid>
                                <Grid item>
                                    *
                                </Grid>
                            </Grid>
                            <Grid item>
                                <AccountTreeIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={4}>
                                <CssTextField  
                                    label={(
                                        <Typography 
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            color={blue[900]}
                                            >
                                            موضوع پروژه
                                        </Typography>
                                    )}
                                    fullWidth
                                    disabled={!isAdmin}
                                    inputProps={{ style: { color: blue[900], fontFamily: "b_mitra"}}}
                                    variant="standard" value={projectName}
                                    onChange={ e => setProjectName( e.target.value )} />
                            </Grid>
                            
                        </Grid>
                        {isAdmin &&
                            <div>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <BorderColorIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={4} sx={{fontFamily: 'b_mitra'}}>
                                        <CssTextField
                                            label={(
                                                <Typography 
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={blue[900]}
                                                    >
                                                    شروع قیمت
                                                </Typography>
                                            )}
                                            fullWidth
                                            disabled={!isAdmin}
                                            inputProps={{ style: { color: blue[900], fontFamily: "b_mitra"}}}
                                            variant="standard" value={estimateCredit}
                                            onChange={ e => setEstimateCredit( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <BorderColorIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={4} sx={{fontFamily: 'b_mitra'}}>
                                        <CssTextField  
                                            label={(
                                                <Typography 
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={blue[900]}
                                                    >
                                                    حداکثر قیمت
                                                </Typography>
                                            )}
                                            fullWidth
                                            disabled={!isAdmin}
                                            inputProps={{ style: { color: blue[900], fontFamily: "b_mitra"}}}
                                            variant="standard" value={totalCredit}
                                            onChange={ e => setTotalCredit( e.target.value )} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <MoreHorizIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={6} sx={{fontFamily: 'b_mitra'}}>
                                        <SelectSearchAuto 
                                            title="انتخاب کاربر"
                                            dataAll={dataUsers} 
                                            selectedValue={selectUser} 
                                            onClose={handlerUserSelect}/>
                                    </Grid>
                                </Grid>
                            </div>
                        }
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <MoreHorizIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={6} sx={{fontFamily: 'b_mitra'}}>
                                <ProgramLangSelect 
                                    title="انتخاب وضعیت پروژه"
                                    dataAll={sellStsList} 
                                    selectValue={sellStsSelect} 
                                    onClose={handlerStatusSelect}/>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <CloudSyncIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <ProgramLangSelect 
                                    title="انتخاب زبان برنامه"
                                    dataAll={langProgram} 
                                    selectValue={programmerLang} 
                                    onClose={handlerLangSelect}/>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <BorderColorIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={4} sx={{fontFamily: 'b_mitra'}}>
                                <CssTextField
                                    label={(
                                        <Typography 
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            color={blue[900]}
                                            >
                                            از تاریخ
                                        </Typography>
                                    )}
                                    fullWidth
                                    disabled={!isAdmin}
                                    inputProps={{ style: { color: blue[900], fontFamily: "b_mitra"}}}
                                    variant="standard" value={dateFrom}
                                    onChange={ e => setDateFrom( e.target.value )} />
                            </Grid>
                            <Grid item>
                                <BorderColorIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={4} sx={{fontFamily: 'b_mitra'}}>
                                <CssTextField  
                                    label={(
                                        <Typography 
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            color={blue[900]}
                                            >
                                            تا تاریخ
                                        </Typography>
                                    )}
                                    fullWidth
                                    disabled={!isAdmin}
                                    inputProps={{ style: { color: blue[900], fontFamily: "b_mitra"}}}
                                    variant="standard" value={dateTo}
                                    onChange={ e => setDateTo( e.target.value )} />
                            </Grid>
                        </Grid>
                        
                        <Grid container spacing={1} alignItems='flex-end' >
                            <Grid item xs={10} sm={10} textAlign={'right'}>
                                <Button 
                                    variant="contained" 
                                    color="primary"
                                    size="small" 
                                    onClick={handelSubmitInsert}
                                    >
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            color={'pink.text'}
                                            >
                                            اعمال فیلتر
                                        </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                        
                    </Grid>
                </div>
            </AccordionDetails>
        </Accordion>
    </div>
  )
}


ReportFilter.propTypes = {
    onClose: PropTypes.func.isRequired,
    // open: PropTypes.bool.isRequired,
    // selectedValue: PropTypes.string.isRequired,
}